import React from "react";
import "./LoanReport.css";
import TopToolbar from "../../global/subcomponents/topToolbar/TopToolbar";
import FeedbackBar from "../../feedbackBar/FeedbackBar";
import withShipment from "../../../withShipment";
import { userInfoSelector } from "../../../redux/selectors/auth";

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns';
import InputAdornment from "@material-ui/core/InputAdornment";
import { customerLoanSelector } from '../../../redux/selectors/loan';
import { listCustomerLoan, saveCustomerLoan } from '../../../redux/actions/loan';

import {
  CardContent,
  Typography,
  IconButton,
  Collapse,
  Divider,
  List,
  ListItem,
  ListItemText, Button
} from '@material-ui/core';
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SpeakerNotesIcon from '@mui/icons-material/SpeakerNotes';
import {Dialog, DialogActions, DialogContent, DialogTitle} from "@material-ui/core";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import AddCircleIcon from "@material-ui/icons/AddCircle";

class LoanReport extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      feedbackBarOpen: false,
      feedbackMessage: "",
      feedbackStatus: "",
      amountInput: "",
      dateInput: new Date().toISOString().split('T')[0],
      nameInput: '',
      loanHistory: {},
      displayOrder: [],
      expanded: {},
      selectedType: null,
      balanceFilter: 'UNPAID',
      // NEW STATE FOR NOTES
      openNoteDialog: false,
      selectedNote: "",
      noteInput:'',
      showForm: false
    };
    this.colorMap = {};
  }


  componentDidMount() {
    this.props.listCustomerLoan({
      locationId: this.props.userInfo.company,
    });
  }

  componentDidUpdate(prevProps) {
  if (prevProps.customerLoanHistory !== this.props.customerLoanHistory) {
    const loanHistoryObj = {};

    // If customerLoanHistory is an object (map)
    const historyMap = this.props.customerLoanHistory || {};
    Object.keys(historyMap).forEach((fullName) => {
      loanHistoryObj[fullName] = historyMap[fullName] || [];
    });

    this.setState({
      loanHistory: loanHistoryObj,
    });
  }
}


  toggleExpand = (name) => {
    this.setState((prev) => ({
      expanded: {
        ...prev.expanded,
        [name]: !prev.expanded[name]
      }
    }));
  };

  getColorForCustomer(name) {
    if (!this.colorMap[name]) {
      this.colorMap[name] = this.getRandomLightColor();
    }
    return this.colorMap[name];
  }

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState({
      feedbackBarOpen: false,
      feedbackStatus: "",
      feedbackMessage: "",
    });
  };

  handleDateChange = (date) => {
    if (date && date.toString() !== "Invalid Date") {
      // format to yyyy-MM-dd string for your existing code logic (optional)
      const formattedDate = date.toISOString().split('T')[0];
      this.setState({ dateInput: formattedDate });
    } else {
      this.setState({ dateInput: "" });
    }
  };

  handleAddTransaction = () => {
    const { amountInput, dateInput, nameInput, loanHistory, selectedType, noteInput } = this.state;

    if (!nameInput.trim()) {
      this.openFeedbackBar("error", "Please provide a name");
      return;
    }

    if (!selectedType) {
      this.openFeedbackBar("error", "Please select a type");
      return;
    }

    if (!amountInput || isNaN(amountInput) || parseFloat(amountInput) <= 0) {
      this.openFeedbackBar("error", "Please enter a valid amount greater than 0");
      return;
    }

    if (!dateInput) {
      this.openFeedbackBar("error", "Please select a date");
      return;
    }

    let amount = parseFloat(amountInput);
    if (selectedType === 'SUBTRACT') amount = -amount;

    const newTransaction = {
      fullName: nameInput,
      amount,
      date: dateInput,
      type: selectedType,
      note: noteInput,
      employeeName: [this.props.userInfo.firstname, this.props.userInfo?.lastname].filter(Boolean).join(' '),
    };

    const updatedHistory = {
      ...loanHistory,
      [nameInput]: [
        newTransaction,
        ...(loanHistory[nameInput] || [])
      ]
    };

    const callback = (error, response) => {
      if (error) {
        this.openFeedbackBar('error', error);
      } else {
        this.setState({
          showForm: false,
          loanHistory: updatedHistory,
          amountInput: "",
          nameInput: "",
          dateInput: new Date().toISOString().split('T')[0],
          noteInput: ""
        });

        this.openFeedbackBar('success', response);
      }
    };

    this.props.saveCustomerLoan({
      loanHistory: updatedHistory,
      locationId: this.props.userInfo.company
    }, callback);
  };



  openNoteDialog = (note) => {
    this.setState({ openNoteDialog: true, selectedNote: note || "" });
  };

  closeNoteDialog = () => {
    this.setState({ openNoteDialog: false, selectedNote: "" });
  };


   getRandomLightColor() {
     const r = Math.floor(Math.random() * 25) + 230; // 230-255
     const g = Math.floor(Math.random() * 25) + 230;
     const b = Math.floor(Math.random() * 25) + 230;
    return `rgb(${r}, ${g}, ${b})`;
  }

  userIsAnAdmin = () => {
    const { userInfo } = this.props;
    const roles = userInfo?.authority || [];
    return roles.includes('ROLE_ADMIN');
  };

  render() {
     const {
      dateInput,
      loanHistory,
      balanceFilter,
      expanded,
      openNoteDialog,
      selectedNote
     } = this.state;

    const orderedNames = Object.keys(loanHistory)
    .filter(name => loanHistory[name]?.length > 0)
    .filter(name => {
      const balance = loanHistory[name].reduce((sum, t) => sum + t.amount, 0);
      if (balanceFilter === 'PAID') return balance === 0;
      return balance !== 0; // UNPAID
    })
    .sort((a, b) => {
      const aDate = new Date(loanHistory[a][0]?.date || 0);
      const bDate = new Date(loanHistory[b][0]?.date || 0);
      return bDate - aDate; // latest first
    });

    return (
      <React.Fragment>
        <TopToolbar
          pageName="Loan Report"
           menuItems={
            this.state.showForm
              ? [
                  {
                    title: 'Back',
                    icon: <KeyboardBackspaceIcon />,
                    onClick: () => this.setState({ showForm: false })
                  }
                ]
              : [
                  {
                    title: 'Add Loan',
                    icon: <AddCircleIcon />,
                    onClick: () => this.setState({ showForm: true })
                  }
                ]
          }
        />

        <div className="loan-container">

          {this.state.showForm ?
            <div className="loan-form">
              <div className="form-row">


              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <KeyboardDatePicker
                    className="form-input"
                    autoOk
                    name="toDate"
                    variant="inline"
                    inputVariant="outlined"
                    label="Date"
                    format="yyyy-MM-dd"
                    required
                    InputAdornmentProps={{position: 'start'}}
                    value={dateInput ? new Date(dateInput) : null}
                    onChange={this.handleDateChange}
                />
              </MuiPickersUtilsProvider>

              <TextField
                className="form-input"
                variant="outlined"
                label="Name"
                required
                InputLabelProps={{ shrink: true }}
                value={this.state.nameInput}
                onChange={(e) => this.setState({ nameInput: e.target.value })}
              />

              <Autocomplete
                  className="form-input"
                  options={['ADD', 'SUBTRACT']}
                  value={this.state.selectedType || null}
                  onChange={(event, newValue) => {
                    this.setState({ selectedType: newValue });
                  }}
                  renderInput={(params) => (
                      <TextField
                          {...params}
                          required
                          name="type"
                          label="Type"
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                      />
                  )}
                  clearOnEscape
              />

              <TextField
                  className="form-input"
                  variant="outlined"
                  label="Amount"
                  InputLabelProps={{ shrink: true }}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">$</InputAdornment>,
                  }}
                  name="amount"
                  required
                  value={this.state.amountInput}
                  onChange={(e) => {
                    // Only allow digits and optional decimal point
                    const value = e.target.value;
                    const sanitizedValue = value.replace(/[^0-9.]/g, '');
                    this.setState({ amountInput: sanitizedValue });
                  }}
                  type="text" // keep as text to fully control input
                  onBlur={() => {
                    let val = parseFloat(this.state.amountInput);
                    if (isNaN(val) || val < 0) val = 0;
                    this.setState({ amountInput: val.toFixed(2) });
                  }}
              />

              <TextField
                  className="form-input"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  label="Note"
                  multiline
                  rows={3}
                  value={this.state.noteInput}
                  onChange={(e) => this.setState({ noteInput: e.target.value })}
                />




              <button onClick={this.handleAddTransaction} className="loan-btn">
                Submit
              </button>
            </div>
            </div>
          :
          <>

            <div className="balance-filter">
            <label>
              <input
                  type="radio"
                  name="balanceFilter"
                  value="UNPAID"
                  checked={this.state.balanceFilter === 'UNPAID'}
                  onChange={(e) => this.setState({ balanceFilter: e.target.value })}
              />
              Unpaid
            </label>
            <label style={{ marginLeft: '20px' }}>
              <input
                  type="radio"
                  name="balanceFilter"
                  value="PAID"
                  checked={this.state.balanceFilter === 'PAID'}
                  onChange={(e) => this.setState({ balanceFilter: e.target.value })}
              />
              Paid
            </label>
          </div>

            {/* All Customers Loan History */}

            {(!this.props.customerLoanHistory || this.props.customerLoanHistory.length === 0) && (
                <div className="no-history-container">
                  <CardContent className="no-history-card">
                    <div className="no-history-icon">
                      <span role="img" aria-label="empty">📄</span>
                    </div>
                    <Typography variant="h6" className="no-history-title">
                      No Loans Added Yet
                    </Typography>
                    <span className="no-history-subtitle">
                      Once you add a record, it will appear here.
                    </span>
                  </CardContent>
                </div>
            )}

            <div className="loan-history-card-container">
              {orderedNames.map((name) => {
              const history = loanHistory[name];
              const balance = history.reduce((sum, t) => sum + t.amount, 0);
              const isExpanded = expanded[name] || false;

              return (
                    <div key={name} className="note-card-loan"
                         style={{ backgroundColor: this.getColorForCustomer(name) }}
                    >
                      {/* Customer Name */}
                      <CardContent className="">
                        <div style={{display:"flex", justifyContent:"space-between"}}>


                        <Typography variant="h6" className="customer-name">
                          {name}
                        </Typography>

                        <IconButton
                            onClick={() => this.toggleExpand(name)}
                            className="toggle-btn"
                            size="small"
                        >
                          {isExpanded ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
                        </IconButton>

                        </div>
                      </CardContent>

                      <Divider className="thin-divider" />

                      {/* Transactions List */}
                      <Collapse in={isExpanded} timeout="auto" unmountOnExit>

                        <CardContent className="transactions-list">
                          <List dense>
                            {history.map((t, i) => (
                                <ListItem
                                    key={i}
                                    className={
                                      t.amount < 0
                                          ? "amount-negative"
                                          : "amount-positive"
                                    }
                                >
                                  <ListItemText
                                      primary={
                                        <>
                                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                                        {`${t.amount < 0 ? "-" : "+"} $${Math.abs(t.amount)}`}
                                      </span>
                                        </>
                                  }
                                      secondary={
                                        <>
                                          {t.date} — <span style={{ fontStyle: "italic" }}>{t.employeeName}</span>
                                        </>
                                      }
                                  />

                                  {/* NOTE ICON */}
                                  {t.note && (
                                    <IconButton onClick={() => this.openNoteDialog(t.note)}>
                                      <SpeakerNotesIcon />
                                    </IconButton>
                                  )}

                                </ListItem>
                            ))}
                          </List>
                        </CardContent>
                      </Collapse>



                      {/* Balance */}
                      <CardContent className="balance-section">
                        <Typography
                            variant="h6"
                            style={{fontSize: '16px',fontWeight:'bold'}}
                            className={
                              balance < 0 ? "amount-negative" : "amount-positive"
                            }
                        >

                          Balance{": "}
                          {balance < 0
                              ? `- $${Math.abs(balance).toFixed(2)}`
                              : `$${balance.toFixed(2)}`}

                        </Typography>
                      </CardContent>
                    </div>
                );
              })}
            </div>

          </>

          }

         </div>


        <Dialog
        fullWidth
          maxWidth="sm"
            disableEnforceFocus
             disableRestoreFocus

        open={openNoteDialog} onClose={this.closeNoteDialog}>
          <DialogTitle style={{marginLeft:'-16px'}}>Notes</DialogTitle>
          <DialogContent style={{marginLeft:'-16px', marginRight:'-16px',marginBottom:'8px'}}>
            <Typography>{selectedNote}</Typography>
          </DialogContent>
          <DialogActions>
            <Button
            variant="contained"
            color="primary"
            onClick={this.closeNoteDialog}>
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <FeedbackBar
            open={this.state.feedbackBarOpen}
            handleClose={this.closeFeedbackBar}
            severity={this.state.feedbackStatus}
            message={this.state.feedbackMessage}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfo: userInfoSelector(state),
  customerLoanHistory: customerLoanSelector(state)
});

const actionCreators = {
  saveCustomerLoan,
  listCustomerLoan

};

export default withShipment({actionCreators, mapStateToProps}, LoanReport);
